// fetch cloud game apps type
export const FETCH_JUNS_GAME_APPS = 'FETCH_JUNS_GAME_APPS'
export const FETCH_CLOUDGAMES_APPS = 'FETCH_CLOUDGAMES_APPS'
